import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 8.252v-1.5m0 1.5q-2.033 0-4.024.167C6.845 8.512 6 9.476 6 10.61v2.514m6-4.872q2.033 0 4.024.167C17.155 8.512 18 9.476 18 10.61v2.514m-3-4.872v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.35 3.35 0 0 1-3 0 3.35 3.35 0 0 0-3 0 3.35 3.35 0 0 1-3 0 3.35 3.35 0 0 0-3 0 3.35 3.35 0 0 1-3 0l-1.5-.75m15-3.378a49 49 0 0 0-6-.372c-2.032 0-4.034.127-6 .372m12 0q.585.072 1.163.16c1.07.16 1.837 1.093 1.837 2.174v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 0 1 3 20.627v-5.169c0-1.08.768-2.015 1.837-2.175A48 48 0 0 1 6 13.123m6.265-10.01a.375.375 0 1 1-.53 0L12 2.846zm-3 0a.375.375 0 1 1-.53 0L9 2.846zm6 0a.375.375 0 1 1-.53 0L15 2.846z"
    }, null, -1)
  ])))
}
export default { render: render }